module.exports = __webpack_public_path__ + "static/media/settings.9d9b1c22.svg";